const jsonToCSV = (jsonData) => {
    if (!jsonData || !jsonData.length) return '';

    const headers = Object.keys(jsonData[0]).join(',');
    const rows = jsonData.map(obj => 
        Object.values(obj)
            .map(value => {
                // If the value is a currency string, remove currency symbol and commas
                if (typeof value === 'string' && value.includes('€')) {
                    return value.replace('€', '').replace(/,/g, '').trim();
                }
                // For other values that might contain commas, wrap in quotes
                if (typeof value === 'string' && value.includes(',')) {
                    return `"${value}"`;
                }
                return value;
            })
            .join(',')
    );

    return [headers, ...rows].join('\n');
};

// Function to download CSV
export const downloadCSV = (jsonData, filename = 'data.csv') => {
    const csv = jsonToCSV(jsonData);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};